export const isItEven = (number) => {
    return number % 2 === 0;
}